import React from 'react';
import { Box, Container } from '@mui/material';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Ticket, TicketStatus } from '@marageti/z4-sdk/lib/tickets';
import { EditableTicket, TicketFormData, AssigneeOption } from '../../tickets/options';
import { TicketCloseFormData } from '../../../components/modals/ticket-close-modal';
import { TicketReassignFormData } from '../../../components/modals/ticket-reassign-modal';
import TicketList from '../../../components/ticket-list';

type TravelerTicketsViewProps = {
  tickets: Ticket[];
  totalHits: number;
  isLoading: boolean;
  error: ApiError | undefined;
  hasMore: boolean;
  loadMore: () => void;
  onEditTicket: (ticket: Ticket) => void;
  onReassignTicket: (ticket: Ticket) => void;
  onDeleteTicket: (ticket: Ticket) => void;
  onStatusChange: (ticketId: string, status: TicketStatus) => void;
  isModalOpen: boolean;
  editingTicket?: EditableTicket;
  assignees: AssigneeOption[];
  defaultAssigneeIds?: string[];
  onCloseModal: () => void;
  onSaveTicket: (data: TicketFormData) => Promise<void>;
  isCloseModalOpen: boolean;
  onCloseCloseModal: () => void;
  onSaveClose: (data: TicketCloseFormData) => Promise<void>;
  isReassignModalOpen: boolean;
  reassigningTicketAssigneeIds: string[];
  onCloseReassignModal: () => void;
  onSaveReassign: (data: TicketReassignFormData) => Promise<void>;
  isDeleteModalOpen: boolean;
  onCloseDeleteModal: () => void;
  onConfirmDelete: () => Promise<void>;
};

const TravelerTicketsView = ({
  tickets,
  totalHits,
  isLoading,
  error,
  hasMore,
  loadMore,
  onEditTicket,
  onReassignTicket,
  onDeleteTicket,
  onStatusChange,
  isModalOpen,
  editingTicket,
  assignees,
  defaultAssigneeIds,
  onCloseModal,
  onSaveTicket,
  isCloseModalOpen,
  onCloseCloseModal,
  onSaveClose,
  isReassignModalOpen,
  reassigningTicketAssigneeIds,
  onCloseReassignModal,
  onSaveReassign,
  isDeleteModalOpen,
  onCloseDeleteModal,
  onConfirmDelete,
}: TravelerTicketsViewProps) => (
  <Container maxWidth="xl">
    <Box py={3}>
      <TicketList
        tickets={tickets}
        totalHits={totalHits}
        isLoading={isLoading}
        error={error}
        hasMore={hasMore}
        loadMore={loadMore}
        onEditTicket={onEditTicket}
        onReassignTicket={onReassignTicket}
        onDeleteTicket={onDeleteTicket}
        onStatusChange={onStatusChange}
        isModalOpen={isModalOpen}
        editingTicket={editingTicket}
        assignees={assignees}
        defaultAssigneeIds={defaultAssigneeIds}
        onCloseModal={onCloseModal}
        onSaveTicket={onSaveTicket}
        isCloseModalOpen={isCloseModalOpen}
        onCloseCloseModal={onCloseCloseModal}
        onSaveClose={onSaveClose}
        isReassignModalOpen={isReassignModalOpen}
        reassigningTicketAssigneeIds={reassigningTicketAssigneeIds}
        onCloseReassignModal={onCloseReassignModal}
        onSaveReassign={onSaveReassign}
        isDeleteModalOpen={isDeleteModalOpen}
        onCloseDeleteModal={onCloseDeleteModal}
        onConfirmDelete={onConfirmDelete}
      />
    </Box>
  </Container>
);

export default TravelerTicketsView;
